import React from "react"

const styles = `
  .ck-product-embed p {
    margin: 0;
  }

  @media only screen and (max-width:600px) {
    .ck-product-embed td {
      display: block !important;
      width: 100% !important;
      padding: 0 !important;
    }

    .ck-product-embed img {
      margin-bottom: 18px !important;
    }
  }
`

// Product embed markup, shared by ProductEmbedEditor and ProductEmbedEmail.
export function ProductEmbedMarkup({ properties, productData: data }) {
  return (
    <div
      className="ck-product-embed"
      style={{
        margin: "24px 0",
        padding: 24,
        border: "1px solid #f0f0f0",
        borderRadius: "8px",
        backgroundColor: properties.backgroundColor
      }}
    >
      <table
        border="0"
        cellPadding="0"
        cellSpacing="0"
        width="100%"
        bgcolor={properties.backgroundColor}
      >
        <tbody>
          <tr>
            {properties.showImage && (
              <td
                width="300"
                style={{ paddingRight: 24, verticalAlign: "top" }}
              >
                <img
                  width="100%"
                  height="auto"
                  style={{
                    maxWidth: "100%",
                    display: "block",
                    borderRadius: "4px"
                  }}
                  src={data.imageUrl}
                  alt={data.imageAlt}
                />
              </td>
            )}
            <td width="400" style={{ verticalAlign: "middle" }}>
              {properties.showPrice && (
                <p
                  style={{ margin: "8px 0 8px", padding: 0 }}
                  dangerouslySetInnerHTML={{ __html: data.price }}
                />
              )}

              <h2 style={{ padding: 0, margin: "8px 0" }}>{data.title}</h2>

              {properties.showDescription && (
                <div dangerouslySetInnerHTML={{ __html: data.description }} />
              )}

              {properties.showButton && (
                <div
                  style={{
                    marginTop: 16
                  }}
                >
                  <a
                    href={data.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      backgroundColor: properties.buttonColor || "#65dc8d",
                      padding: "8px 12px",
                      fontWeight: 600,
                      color: properties.buttonTextColor || "#FFFFFF",
                      borderRadius: "4px",
                      textDecoration: "none",
                      border: "none"
                    }}
                  >
                    {properties.buttonText || data.buttonText}
                  </a>
                </div>
              )}
            </td>
          </tr>
        </tbody>
      </table>
      <style>{styles}</style>
    </div>
  )
}
